import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  updateJobEventWorkforce,
  updateJobDefaultWorkforce,
  BulkUpdateJobEventsParams,
  bulkUpdateJobEventsWorkforce,
} from "../jobs-layout/actions/useUpdateJobEventWorkforce";

export const useUpdateJobEventWorkforceAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateJobEventWorkforce,
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
};

export const useUpdateJobDefaultWorkforceAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateJobDefaultWorkforce,
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
};

export function useBulkUpdateEventWorkforce() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: BulkUpdateJobEventsParams) => bulkUpdateJobEventsWorkforce(payload),
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
}
